import { Component, inject, OnInit, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TenantService } from '../../../shared/services/tenant.service';
import { Tenant } from '../../../shared/models/user.model';
import { ConfirmModalComponent } from '../../../shared/utils/modal-validation/modal-validation';
import { AddTenantComponent } from '../add-tenant/add-tenant';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list-tenant',
  imports: [CommonModule, FormsModule, ConfirmModalComponent, AddTenantComponent],
  templateUrl: './list-tenant.html'
})
export class ListTenantComponent implements OnInit, OnDestroy {
  private tenantService = inject(TenantService);
  private subscription?: Subscription;

  loading = true;
  tenants: Tenant[] = [];

  // Add-tenant modal
  showAddModal = false;

  closeAddModal() {
    this.showAddModal = false;
    this.tenantService.listTenants();
  }

  // Menu and confirmation state
  openMenuId?: string;
  showConfirmDelete = false;
  tenantToDelete?: string;

  // Edit state
  editingTenantId?: string;
  editingName = '';

  @HostListener('document:click')
  onDocumentClick() {
    this.openMenuId = undefined;
  }

  toggleMenu(tenantId: string | undefined, event: Event) {
    event.stopPropagation();
    if (!tenantId) return;
    this.openMenuId = this.openMenuId === tenantId ? undefined : tenantId;
  }

  ngOnInit() {
    this.subscription = this.tenantService.tenants$.subscribe(tenants => {
      this.tenants = tenants;
      this.loading = false;
    });
    this.tenantService.listTenants();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async refresh() {
    this.loading = true;
    await this.tenantService.listTenants();
  }

  startEdit(tenant: Tenant, event: Event) {
    event.stopPropagation();
    this.openMenuId = undefined;
    this.editingTenantId = tenant.id;
    this.editingName = tenant.name;
  }

  cancelEdit() {
    this.editingTenantId = undefined;
    this.editingName = '';
  }

  async saveEdit(tenantId: string) {
    if (!this.editingName.trim()) return;
    await this.tenantService.updateTenant(tenantId, { name: this.editingName.trim() });
    this.editingTenantId = undefined;
    this.editingName = '';
  }

  async toggleActive(tenant: Tenant) {
    await this.tenantService.updateTenant(tenant.id, { isActive: !tenant.isActive });
  }

  confirmDelete(tenantId: string | undefined, event: Event) {
    event.stopPropagation();
    if (!tenantId) return;
    this.openMenuId = undefined;
    this.tenantToDelete = tenantId;
    this.showConfirmDelete = true;
  }

  async handleConfirmDelete(result: 'ok' | 'cancel') {
    this.showConfirmDelete = false;
    if (result === 'ok' && this.tenantToDelete) {
      await this.tenantService.deleteTenant(this.tenantToDelete);
    }
    this.tenantToDelete = undefined;
  }
}
